export class Ajax {

  static get(url) {
    return fetch(url, 
    {
      "headers" : {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.json())
      .catch(error => console.error(error));
  }

  static post(url, data, contentType = "formData", options = null) {

    try{
      switch( contentType ){
      case "formData":
        return fetch(url, {
          method: "POST",
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: data
        })
        .then(response => {
          if( options !== null ){
            if( options.responseType !== null ){
              switch(options.responseType){
                case "rawHTML":
                  return response.text();
                break;
              }
            }else{
              return response.json();
            }
          }else{
            return response.json()
          }
        })
        .catch(error => console.error(error));
      break;
      case "x-www-form-urlencoded":
        let formData = new FormData();
        for (let key in data) {
          formData.append(key, data[key]);
        }
        return fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new URLSearchParams(formData).toString()
        })
        .then(response => {
          if( options !== null ){
            if( options.responseType !== null ){
              switch(options.responseType){
                case "rawHTML":
                  return response.text();
                break;
              }
            }else{
              return response.json();
            }
          }else{
            return response.json()
          }
        })
        .catch(error => console.error(error));
      break;
      case "json":
        return fetch(url, {
          method: "POST",
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            "Content-Type": "application/json"
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if( options !== null ){
            if( options.responseType !== null ){
              switch(options.responseType){
                case "rawHTML":
                  return response.text();
                break;
              }
            }else{
              return response.json();
            }
          }else{
            return response.json();
          }
        })
        .catch(error => console.error(error));
      break;

    }
    }catch(e){
      console.log(e);
    }

  }

}